import { render } from "./FeedbackMainTable.vue?vue&type=template&id=09536e28&scoped=true&ts=true"
import script from "./FeedbackMainTable.vue?vue&type=script&lang=ts"
export * from "./FeedbackMainTable.vue?vue&type=script&lang=ts"

import "./FeedbackMainTable.vue?vue&type=style&index=0&id=09536e28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09536e28"]])

export default __exports__